<template lang="pug">
  //- This template should only be used in components/chat/Bubble.vue
  div(class="c-image-thumbnail" @click="onClick()" data-testid="image-thumbnail-container")
    img(:src="url" class="c-image-thumbnail__img" data-testid="image-thumbnail-img")
</template>

<script>
export default {
  name: 'ImageThumbnail',
  props: {
    url: {
      type: String,
      required: true,
    },
  },
  methods: {
    onClick() {
      this.$emit('media-thumbnail-click', { url: this.url, mediaType: 'image' });
    },
  },
};
</script>

<style lang="scss" scoped>
.c-image-thumbnail {
  max-width: 200px;
  height: 120px;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;

  &__img {
    width: auto;
    height: 100%;
    object-fit: cover;
  }
}
</style>
